export const stringArraysEqualIgnoreOrder = (a: string[], b: string[]): boolean => {
	return JSON.stringify([...a].sort()) === JSON.stringify([...b].sort());
};

export const areStringArraysEqual = (a: string[] = [], b: string[] = []): boolean => {
	if (a.length !== b.length) return false;
	return a.every(role => b.includes(role));
};

export const shallowEqual = <T extends Record<string, any>>(a: T, b: T): boolean => {
	const keysA = Object.keys(a);
	const keysB = Object.keys(b);

	if (keysA.length !== keysB.length) return false;

	return keysA.every(key => {
		const valA = a[key];
		const valB = b[key];

		// Ignore arrays entirely
		if (Array.isArray(valA) && Array.isArray(valB)) {
			return true;
		}

		return valA === valB;
	});
};
